import { SecurityQuestionAnswerAuditableResponse } from 'src/app/web-api-client';
import { SecurityType } from '../../admin/models';
import { InvestmentJurisdictionShort } from '../../admin/models/investment-jurisdiction-short';
import { TransactionType } from '../../admin/models/transaction-type';
import { Entity } from './entity';
import { TaxResult } from './taxResult';

export class SecurityDetails {
  securityId?: number;
  entity?: Entity | null;
  clientId?: number | null;
  generalRateEntityTypeId?: number | null;
  generalRateEntityTypeName?: string | null;
  name?: string | null;
  isinCusip?: string | null;
  securityType?: SecurityType | null;
  investmentJurisdiction?: InvestmentJurisdictionShort | null;
  acquisitionDate?: Date | null;
  dispositionDate?: Date | null;
  transactionType?: TransactionType | null;
  taxResults?: TaxResult[];
  statusId?: number;
  questions?: SecurityQuestionAnswerAuditableResponse[];
  created?: Date;
  modified?: Date;
  clientName?: string;
  comments?: string;
  constructor(security?: SecurityDetails) {
    this.securityId = security?.securityId;
    this.entity = security?.entity;
    this.clientId = security?.clientId;
    this.generalRateEntityTypeId = security?.generalRateEntityTypeId;
    this.generalRateEntityTypeName = security?.generalRateEntityTypeName;
    this.name = security?.name;
    this.isinCusip = security?.isinCusip;
    this.securityType = security?.securityType;
    this.investmentJurisdiction = security?.investmentJurisdiction;
    this.acquisitionDate = security?.acquisitionDate;
    this.dispositionDate = security?.dispositionDate;
    this.transactionType = security?.transactionType;
    this.taxResults = security?.taxResults;
    this.statusId = security?.statusId;
    this.questions = security?.questions;
    this.created = security?.created;
    this.modified = security?.modified;
    this.clientName = security?.clientName;
    this.comments = security?.comments;
  }
}
